<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<ng-container *ngIf="!isLoadingResults && question$ | async as question">

  <form [formGroup]="form">
    <mat-checkbox formControlName="notApply">
      {{'forms.common.a1' | translate}}
    </mat-checkbox>
    <br />

    <!-- We have another case here : hasEvaluationItems -->
    <ng-container *ngIf="!form.controls.notApply.value">
      <mat-label class="font-weight-bold field-required">{{ "forms.common.Criteria.questionCompliance" | translate }}
      </mat-label>
      <mat-radio-group formControlName="reviewerEvaluation" class="complianceContainer">
        <mat-radio-button [value]="item.value" *ngFor="let item of answers$ | async">
          {{item.value}}

          <mat-icon class="info" *ngIf="item.hasTooltip"
            [matTooltip]="item | propertyLocalized : ['tooltipAr', 'tooltipEn'] | async">
            info
          </mat-icon>
        </mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="form.errors?.answerInvalid">
        {{
        question
        | propertyLocalized : ["errorAr", "errorEn"]
        | async
        }}
      </mat-error>
      <br />
    </ng-container>


    <ng-container *ngIf="!form.controls.notApply.value">
      <app-copy-decision (clicked)="copy('termsOfTheRulingWithEvidence')" [enabledCopy]="enabledCopy"
        [tooltip]="'forms.common.Criteria.copyEvidence'">
        <mat-label class="font-weight-bold" [ngClass]="{'field-required': !form.controls.notApply.value}">
          {{ "forms.common.Criteria.Evidence" | translate }}
        </mat-label>
      </app-copy-decision>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
          formControlName="termsOfTheRulingWithEvidence"></textarea>
      </mat-form-field>

      <ng-container *ngIf="!!form.controls.termsOfTheRulingWithEvidence.value">
        <div class="d-flex flex-column">
          <mat-label class="font-weight-bold field-required">
            {{ "forms.common.Criteria.Attachments" | translate }}
          </mat-label>
          <input hidden formControlName="attachments" />
          <formio style="margin-top: {{isFormDisabled ? '0' : '-50px'}};" #forms
            [submission]="{ data: { attachments: form.controls.attachments.value}}" [formKey]="attachmentFormKey"
            [showLoader]="false" [readOnly]="isFormDisabled" [viewOnly]="isFormDisabled"
            (formLoad)="registerFormioEvent($event)">
          </formio>
        </div>
      </ng-container>
    </ng-container>

    <app-copy-decision (clicked)="copy('notes')" [enabledCopy]="enabledCopy">
      <mat-label class="font-weight-bold">{{ "forms.common.Criteria.Notes" | translate }} </mat-label>
    </app-copy-decision>
    <mat-form-field appearance="outline">
      <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="notes"></textarea>
    </mat-form-field>

    <ng-container *ngIf="!form.controls.notApply.value">
      <app-copy-decision (clicked)="copy('summaryOfCommendations')" [enabledCopy]="enabledCopy">
        <mat-label class="font-weight-bold" [ngClass]="{'field-required': !form.controls.notApply.value}">
          {{ "forms.common.Criteria.summaryOfCommendations" | translate }}
        </mat-label>
      </app-copy-decision>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
          formControlName="summaryOfCommendations"></textarea>
      </mat-form-field>

      <app-copy-decision (clicked)="copy('summaryOfSuggestions')" [enabledCopy]="enabledCopy">
        <mat-label class="font-weight-bold" [ngClass]="{'field-required': !form.controls.notApply.value}">
          {{ "forms.common.Criteria.summaryOfSuggestions" | translate }}
        </mat-label>
      </app-copy-decision>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
          formControlName="summaryOfSuggestions"></textarea>
      </mat-form-field>

      <app-copy-decision (clicked)="copy('summaryOfRecommendations')" [enabledCopy]="enabledCopy">
        <mat-label class="font-weight-bold" [ngClass]="{'field-required': !form.controls.notApply.value}">
          {{ "forms.common.Criteria.summaryOfRecommendations" | translate }}
        </mat-label>
      </app-copy-decision>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
          formControlName="summaryOfRecommendations"></textarea>
      </mat-form-field>

      <app-copy-decision (clicked)="copy('executiveSummary')" [enabledCopy]="enabledCopy">
        <mat-label class="font-weight-bold" [ngClass]="{'field-required': !form.controls.notApply.value}">
          {{ "forms.common.Criteria.executiveSummary" | translate }}
        </mat-label>
      </app-copy-decision>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="executiveSummary"></textarea>
      </mat-form-field>

      <app-copy-decision (clicked)="copy('conditions')" [enabledCopy]="enabledCopy">
        <mat-label class="font-weight-bold">{{ "forms.common.Criteria.Conditions" | translate }} </mat-label>
      </app-copy-decision>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="conditions"></textarea>
      </mat-form-field>
    </ng-container>

    <div class="d-flex justify-content-end" *ngIf="!isFormDisabled">
      <button class="mt-3" mat-flat-button (click)="submit()" color="primary" [disabled]="form.invalid">
        {{ "forms.common.Criteria.save" | translate }}
      </button>
    </div>
  </form>
</ng-container>
